<template>
  <div class="home">
    <FirstView/>
    <a id="home" style="visibility: hidden"></a>
    <Hero />
    <Divider v-bind:divider="div1" />
    <a id="about" style="visibility: hidden"></a>
    <Intro />
    <Divider v-bind:divider="div2" />
    <a id="staff" style="visibility: hidden"></a>
    <Staff />
    <Divider v-bind:divider="div3" />
    <a  id="news" style="visibility: hidden"></a>
    <News />
    <Divider v-bind:divider="div4" />
    <a  id="dates" style="visibility: hidden"></a>
    <Dates />
    <Divider v-bind:divider="div5" />
    <a id="contact" style="visibility: hidden"></a>
    <Contact />
    <Footer />
  </div>
</template>

<script>
// import Woosh from './components/Woosh.vue'
import FirstView from './components/FirstView.vue'
import Hero from './components/Hero.vue'
import Intro from './components/JazzterdaysIntro.vue'
import Divider from './components/Divider.vue'
import Staff from './components/Staff.vue'
import News from './components/News.vue'
import Dates from './components/Dates.vue'
import Contact from './components/Contact.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'Home',
  components: {
    // Woosh,
    FirstView,
    Hero,
    Intro, 
    Divider,
    Staff,
    News,
    Dates,
    Contact,
    Footer
  },
  data() {
    return {
      div1: {
        url: "/divider/div_1.png",
        alt: "Sepia image with singer",
      },
      div2: {
        url: "/divider/div_2.png",
        alt: "other",
        overlayUrl: "/divider/div_piano_1.png"
      },
      div3: {
        url: "/divider/div_3.png",
        alt: "other",
        overlayUrl: "/divider/div_sax_1.png"
      },
      div4: {
        url: "/divider/div_4.png",
        alt: "other"
      },
      div5: {
        url: "/divider/div_5.png",
        alt: "other"
      }
    }
  }
}
</script>


<style lang="scss" global>
  @import url('https://fonts.googleapis.com/css2?family=Fauna+One&display=swap');
  @import '~vuetify/src/styles/settings/_variables.scss';


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background-color: #E4E4E4;
}

 .light_bg {
    background-color: #F2EFE8;
    min-height: 10rem;
    
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      padding-left: 50px;
      padding-right: 50px;
    }
  
  }
  .white_bg {
    background-color: #ffffff;
    // background-color: #E4E4E4;
    min-height: 10rem;
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      padding-left: 50px;
      padding-right: 50px;
    }
  
  }

  .dark_bg {
    background-color: #37383A;
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      padding-left: 50px;
      padding-right: 50px;
    }
  
    // position:relative;
  }

  .non_bg{
    min-height: 10rem;

    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      min-height: 10rem;
      padding-left: 50px;
      padding-right: 50px;
    }
  
  }

  .blue_bg {
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      padding-left: 50px;
      padding-right: 50px;
    }
  
    color: #1765B3;
    min-height: 10rem;
  }

  .top_space {
    padding-top: 10rem;

    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      padding-top: 10rem;
    
    }
  }

  .top_space_more {
    padding-top: 20rem;

    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      padding-top: 16rem;
    
    }
  }

  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    .container {
      max-width: 1024px;
    }
  }

</style>